export const USERS = {
  INTERNAL_USERS: [
    'DiMS_DISPUTE_ANALYST',
    'DiMS_SENIOR_DISPUTE_ANALYST',
    'DiMS_DISPUTE_SUPERVISOR',
    'DiMS_DISPUTE_MANAGER',
    'DiMS_DISPUTE_SUPPORT',
    'DiMS_PRODUCTION_SUPPORT',
    'DiMS_ADMIN_USER',
    'DiMS_SETTLEMENT_ANALYST',
    'DiMS_INTERNAL_EMPLOYEE',
    'DiMS_DISPUTE_PRODUCT_MANAGER',
  ],
  EXTERNAL_USERS: [
    'DiMS_ACCOUNT_ADMIN',
    'DiMS_ACCOUNT_USER',
    'DiMS_ACQUIRER_ADMIN',
    'DiMS_ACQUIRER_USER',
    'DiMS_HPY_ACCOUNT_USER',
  ],
};
